import React, { useState, useContext } from 'react';
import { Container, TextField, Button, Typography, Box, Alert } from '@mui/material';
import { AuthContext } from '../contexts/AuthContext';
import {Link, useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const [usernameOrEmail, setUsernameOrEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      await auth?.login(usernameOrEmail, password);
      navigate('/parsing/channel-message');
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Ошибка входа');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Typography variant="h4" sx={{ textAlign: 'center', color: '#1E3A8A', fontWeight: 'bold', mb: 4 }}>
        Вход
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          label="Логин или Email"
          value={usernameOrEmail}
          onChange={(e) => setUsernameOrEmail(e.target.value)}
          fullWidth
          required
          variant="outlined"
        />
        <TextField
          label="Пароль"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
          required
          variant="outlined"
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{ bgcolor: '#1E3A8A', '&:hover': { bgcolor: '#1E40AF' }, py: 1.5 }}
        >
          Войти
        </Button>
        {/* Вставь после кнопки "Войти" */}
        <Box sx={{textAlign: 'center', mt: 3}}>
          <Button component={Link} to="/forgot-password" variant="text" sx={{color: '#60A5FA', fontWeight: 600}}>
            Забыли пароль?
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default Login;